import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://joxgrypqufhlgvhqpjeu.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpveGdyeXBxdWZobGd2aHFwamV1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU4MzM2MDQsImV4cCI6MjA4MTQwOTYwNH0.a3ZiiU2t5DJ-l1ckML55Bnvq2OFNkKCTPtZrq_7Qfos";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
